import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FieldAdministrationRoutingModule } from './field-administration-routing.module';
import { FieldAdministrationComponent } from './field-administration.component';
import { DxDataGridModule, DxSelectBoxModule, DxTextBoxModule, DxCheckBoxModule, DxTagBoxModule, DxAutocompleteModule } from 'devextreme-angular';
import { I18nModule } from 'app/shared/i18n/i18n.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FieldAdministrationComponent],
  imports: [
    CommonModule,
    FieldAdministrationRoutingModule,
    DxDataGridModule,
    I18nModule,
    ReactiveFormsModule,
    FormsModule,
    DxSelectBoxModule,
    DxTextBoxModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxAutocompleteModule
  ]
})
export class FieldAdministrationModule { }
